import React from "react";
import { Box, Stack } from "@mui/material";
import { ColorSystemProps } from "../../../constants";

export function ChapterMark({
  num,
  category,
  dark = false,
  mainColor,
}: {
  num: string;
  category: string;
  dark?: boolean;
  mainColor: ColorSystemProps;
}) {
  return (
    <Stack direction="row" alignItems="center" gap="12px">
      <Box
        style={{
          width: "3px",
          height: "16px",
          background: dark ? mainColor.c200 : mainColor.c400,
          borderRadius: "1px",
          flexShrink: 0,
        }}
      />
      <Box
        style={{
          fontSize: "12px",
          fontWeight: 800,
          color: dark ? mainColor.c200 : mainColor.c500,
          letterSpacing: "0.14em",
          fontFeatureSettings: '"tnum" on',
        }}
      >
        {num}
      </Box>
      <Box
        style={{
          fontSize: "11px",
          fontWeight: 700,
          color: dark ? "#b9b9b9" : "#686868",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
        }}
      >
        {category}
      </Box>
    </Stack>
  );
}
